<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
	<div class="m-content">
			<!-- FORM -->
			<form
			[formGroup]="form"
			*ngIf="form"
			class="m-form m-form--fit m-form--label-align-right">
				<div>
					<!-- EVENT -->
					<div class="m-portlet">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="m-portlet__head-title">
									<h3 class="m-portlet__head-text" *ngIf="!ppw">
										TEAM INFORMATION
									</h3>
								</div>
							</div>
						</div>
						<div class="m-portlet__body">
							<div class="m-form__section m-form__section--first">
								<div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Team Name:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="name"
											type="text"
											id="name"
											class="form-control m-input"
											placeholder=""
											/>
										<app-validation-display
											[control]="form.controls.name"
											errorMessage="Please enter a valid team name"
											></app-validation-display>
									</div>
								</div>
                                <div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Team Logo:
									</label>
									<div class="col-lg-4">
                    <input
                      type="file"
                      (change)="uploadImage($event.target.files[0])"
                      name="file-1[]"
                      id="file-1"
                      class="venue-fileinput"
                      accept="image/*"
                    />
                    <img
                      *ngIf="formControls('logoUrl').value !== ''"
                      alt="" [src]="formControls('logoUrl').value" style="display: block;">
                    <span
										  onselectstart="return false"
                      class="img-text"
                      style="display: block;"
                      >
                        Click here to upload an image of your logo. The image must have a minimum width and height of 240px and an aspect ratio of 1:1.
                    </span>
                    <app-validation-display
                      *ngIf="formControls('logoUrl')?.errors?.required === true"
                      [control]="formControls('logoUrl')"
                      errorMessage="This file is required.">
                    </app-validation-display>
										<app-validation-display
                      *ngIf="formControls('logoUrl')?.errors?.invalid === true"
                      [control]="formControls('logoUrl')"
                      errorMessage="Please upload a logo with valid dimensions.">
                    </app-validation-display>
                    <app-validation-display
                      *ngIf="formControls('logoUrl')?.errors?.formatError === true"
                      [control]="formControls('logoUrl')"
                      errorMessage="Please upload a logo with valid format.">
                    </app-validation-display>
                  </div>
								</div>
                  <div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Sport:
									</label>
									<div class="col-lg-3">
										<input
											formControlName="sport"
											type="text"
											id="sport"
											class="form-control m-input"
											placeholder=""
											/>
										<app-validation-display
											[control]="form.controls.sport"
											errorMessage="Please enter a valid sport"
										></app-validation-display>
									</div>
								</div>
                                <div class="form-group m-form__group row">
									<label class="col-lg-4 col-form-label">
									Description:
									</label>
									<div class="col-lg-3">
										<textarea
											formControlName="description"
											type="text"
											id="description"
											class="form-control m-input"
											placeholder=""
											></textarea>
										<app-validation-display
											[control]="form.controls.description"
											errorMessage="Please enter a valid description"
										></app-validation-display>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- END EVENT -->
				</div>

		</form>
		<!-- END FORM -->

		<div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button [debounceClick]  [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
				{{ teamId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				{{ teamId ? 'Cancel' : 'Go Back'}}
				</button>
				<div *ngIf="hasValidationErrors">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>

	</div>
</div>
